<template>
  <div>
    <b-modal
      id="refer-colleague-modal"
      ref="refer"
      hide-footer
      size="xl"
      class="v3_modal font_Montserrat"
      :visible="visible"
      @hidden="onModalHidden"
    >
      <template slot="modal-header-close">
        <span>Close window</span>
        <i class="mdi mdi-close-circle-outline" />
      </template>
      <div
        class="font_size_1000rem font_weight_bold v3_color_black_knight"
      >
        Refer a Colleague
      </div>
      <half-circle-spinner v-if="isLoading" />
      <template v-else>
        <form ref="form" @submit.prevent="validateState" class="mt-4">
          <p>
            {{ content.subject ? content.subject : defaultSubject }}
          </p>
          <p>
            {{ body }}
          </p>
          <b-form-group
            label="Colleague's E-mail:"
            label-class="font_size_1000rem text-uppercase v3_color_teal "
            :invalid-feedback="emailInvalidFeedback"
          >
            <b-row>
              <b-col lg="6" sm="12" cols="12"  class="mt-3">
                <b-form-input
                  id="name-input"
                  class="rounded_0 border_black_knight"
                  placeholder="Enter Email"
                  v-model="$v.email.$model"
                  :state="validateState('email')"
                  type="email"
                  required
                />
              </b-col>
              <b-col lg="2" sm="12" cols="0"></b-col>
              <b-col lg="2" sm="6" cols="12" class="align-items-center justify-content-end mt-3">
                <b-button
                  variant="v3_red_outline"
                  class="px-5 w-100"
                  @click="$refs.refer.hide()"
                >
                  Cancel
                </b-button>
              </b-col>
              <b-col lg="2" sm="6" cols="12" class="align-items-center justify-content-end mt-3">
                <a
                  :href="href"
                  class="btn btn-v3_teal_outline px-5 w-100"
                  @click="checkEmail"
                >
                  Send
                </a>
              </b-col>
            </b-row>
          </b-form-group>
          <div
            class="text-center pt-3 row-cols-3 d-flex justify-content-center"
          >
          </div>
        </form>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { email, required } from 'vuelidate/lib/validators';
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';
import {ROLE_MSS_RECRUITER} from "@/helpers/rbacHelper";
import {GUEST_USER_ROLES} from "@/store";

export default {
  name: 'ReferColleagueModal',
  mixins: [validationMixin],
  components: {
    HalfCircleSpinner,
  },
  model: {
    prop: 'visible',
    event: 'close',
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    societyName: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      email: null,
      content: null,
      isLoading: false,
      defaultSubject: 'Do You Know Your Real Professional Value? Would You Like To…?',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  created: function () {
    this.getContent();
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    emailInvalidFeedback: function () {
      return !this.$v.email.email
        ? "Colleague's Email must be a valid email."
        : "Colleague's Email is required.";
    },
    subject: function () {
      if (this.content && this.content.subject) {
        return encodeURIComponent(this.content.subject);
      }
      return encodeURIComponent(this.defaultSubject);
    },
    encodedSocietyName: function () {
      return encodeURIComponent(this.societyName);
    },
    body: function () {
      if (this.content && this.content.body) {
        return this.content.body;
      }
      return (
        `The ${this.encodedSocietyName} is asking its members if they are interested in access to free and unlimited ` +
        'compensation and productivity information specific to your specialty and your professional role. ' +
        'Look for and respond to the recent email from the SLS to you (“New Benefit for SLS Members! ' +
        'Specialty-Specific Compensation and Practice Information”) to express your interest – ' +
        'I’ve shared my views and encourage you to do the same. ' +
        '%0D' +
        '%0D' +
        'Go to Phairify https://www.phairify.com/how-it-works to learn more about physician ' +
        'and affiliated medical professional value information tools.'
      );
    },
    href: function () {
      return `mailto:${this.email}?subject=${this.subject}&body=${this.body}`;
    },
  },
  methods: {
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];

      this.$emit('valid', $dirty ? !$error : false);

      return $dirty ? !$error : null;
    },
    onModalHidden: function () {
      this.$emit('cancel');
    },
    checkEmail: function (e) {
      this.$v.$touch();

      if (this.$v.$anyError) {
        e.preventDefault();
        return false;
      }

      this.$refs.refer.hide(true);
    },
    getContent: async function () {
      this.isLoading = true;
      try {
        let isRecruiter = false;
        console.log(this.$store.state.user)
        if ((this.$store.state.user && this.$store.state.user.roles.includes(ROLE_MSS_RECRUITER))
            || (!this.$store.state.user && this.$store.state.guestCurrentRole === GUEST_USER_ROLES.ROLE_RECRUITER)) {
          isRecruiter = true;
        }

        this.content = await Api.getReferAColleagueDynamicContent(isRecruiter);
      } catch {
        this.$toasted.error(
          'Unable to upload page content. Please try again later',
          { duration: 3000 }
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style />
